<template>
	<div>
		<Tabs>
			<TabPane label="层级结构" name="tree" icon="ios-git-merge">
				<Tree :data="data2" :render="renderContent"></Tree>
			</TabPane>
			<TabPane label="列表结构" name="list" icon="ios-list">
				<Row style="padding-bottom: 10px;margin-top: 10px;">
					<Button type="primary" @click="">搜索</Button>
					<Button type="primary" icon="md-cloud-upload" style="margin-left: 20px;"
						@click="clickImport">导入Excel</Button>
					<Button type="primary" style="margin-left: 20px;" @click="downTemplate">下载模版</Button>
				</Row>
				<Table ref="selectionTable" :max-height="height" :data="data1" :columns="columns1" stripe border>
					<template slot-scope="{ row, index }" slot="deparams">
						<div style="display: flex;justify-content: space-around;">
							<Button v-if="row.customerIdCard==null||row.customerIdCard==''" type="primary"
								@click="clickBindCustomer(row)" style="padding: 5px 5px 6px;">绑定户主</Button>
							<Button v-else type="primary" @click="clickUnbindCustomer(row)"
								style="padding: 5px 5px 6px;">解绑户主</Button>
						</div>
					</template>
				</Table>
				<Page :current="currentPage" :total="totalRows" :page-size="pageSize" show-sizer show-total
					@on-change="changePage" @on-page-size-change="changePageSize" style="text-align:right"></Page>
			</TabPane>
		</Tabs>

		<Upload ref="upload" name="file" :action="importUrl" :on-success="onUploadSuccess" :format="['xlsx','xls']"
			:show-upload-list="false" style="display: none;">
			<Button />
		</Upload>

		<Modal title="Title" v-model="modal8" :mask-closable="false" width="380">
			<p slot="header" style="color:#0066FF;text-align:center">
				<Icon type="md-create" />
				<span>搜索</span>
			</p>
			<div style="text-align:center">
				<CheckboxGroup v-model="selectedCondition" class="check_grop">
					<div>
						<Checkbox label="meterId">
							<span>表号</span>
						</Checkbox>
						<Input v-model="meterId" placeholder="请输入表号" style="width: 200px" />
					</div>
				</CheckboxGroup>
			</div>
			<div slot="footer">
				<Button icon="md-search" type="info" size="large" long @click="searchByCondition">检索</Button>
			</div>
		</Modal>

		<Modal title="Title" v-model="showBindCustomer" width="500">
			<p slot="header" style="color:#0066FF;text-align:center">
				<span>绑定户主</span>
			</p>
			<div style="text-align: center;">
				<Input v-model="bindCustomerIdCard" placeholder="请输入户主身份证号" style="width: 200px;" />
				&nbsp;
				<Button type="primary" :loading="submitLoading" @click="submitBindCustomer">立即绑定</Button>
			</div>
			<div slot="footer">

			</div>
		</Modal>

		<Modal title="Title" v-model="showDialog" class="common_update_dialog">
			<div slot="header">
				<span>{{showTitle}}</span>
			</div>
			<div v-if="showType=='show'">
				<span>编号</span>
				<Input readonly v-model="currentRow.id" />
			</div>
			<div>
				<span>名称</span>
				<Input :readonly="showType=='show'" v-model="currentRow.name" />
			</div>
			<div>
				<span>公司编号</span>
				<Input :readonly="showType=='show'" v-model="currentRow.companyNum" />
			</div>
			<div>
				<span>户主身份证号</span>
				<Input :readonly="showType=='show'" v-model="currentRow.customerIdCard" />
			</div>
			<div>
				<span>计价方案编号</span>
				<Input :readonly="showType=='show'" v-model="currentRow.valuationId" type="number" />
			</div>
			<div>
				<span>备注</span>
				<Input :readonly="showType=='show'" v-model="currentRow.remark" />
			</div>
			<div v-if="showType=='show'">
				<span>创建时间</span>
				<Input readonly v-model="currentRow.createTime" />
			</div>
			<div slot="footer">
				<Button v-if="showType=='save'||showType=='update'" :loading="submitLoading" type="info" size="large"
					long @click="submitTreeUpdate">立即提交</Button>
			</div>
		</Modal>
	</div>
</template>

<script>
	export default {
		name: "address_manage",
		data() {
			let that = this;
			return {
				height: window.innerHeight,
				buttonProps: {
					type: "default",
					size: "small"
				},
				columns1: [{
						title: "编号",
						width: 100,
						key: "id",
						align: "center"
					},
					{
						title: "父级编号",
						width: 100,
						key: "parentId",
						align: "center"
					},
					{
						title: "公司编号",
						width: 150,
						key: "companyNum",
						align: "center"
					},
					{
						title: "类型",
						width: 100,
						key: "type",
						align: "center"
					},
					{
						title: "名称",
						width: 100,
						key: "name",
						align: "center"
					},
					{
						title: "上级地址",
						width: 300,
						key: "parentName",
						align: "center"
					},
					{
						title: "户主身份证号",
						width: 200,
						key: "customerIdCard",
						align: "center"
					},
					{
						title: "备注",
						width: 150,
						key: "remark",
						align: "center"
					},
					{
						title: "创建时间",
						width: 200,
						key: "createTime",
						align: "center",
						render: function(h, params) {
							return h(
								"div",
								global.dateFtt(
									"yyyy-MM-dd hh:mm:ss",
									new Date(params.row.createTime)
								)
							);
						}
					},
					{
						title: "操作",
						fixed: 'right',
						width: 100,
						slot: "deparams",
						align: "center"
					}
				],
				meterId: '',
				importUrl: '/api/meter/admin/address/imports',
				templateUrl: 'http://www.cnzhuocheng.cn/' + encodeURIComponent('地址导入模板.xls'),
				currentRow: {},
				data1: [],
				data2: [],
				loading: true,
				submitLoading: false,
				modal8: false,
				currentPage: 1,
				totalRows: 0,
				pageSize: 30,
				selectedCondition: [],
				requestBody: {},
				showBindCustomer: false,
				bindCustomerIdCard: '',
				showType: 'show',
				showTitle: '详情',
				isRoot: false,
				showDialog: false,
			};
		},
		created() {
			this.getDataList();
			this.getDataTree();
		},
		mounted() {

		},
		methods: {
			dateFtt(fmt, date) {
				return global.dateFtt(fmt, new Date(date));
			},
			clickImport() {
				this.$refs.upload.$el.children[0].children[0].dispatchEvent(new MouseEvent('click'));
			},
			onUploadSuccess(response, file, fileList) {
				if (!response.success) {
					this.$Notice.error({
						title: "异常",
						desc: response.msg
					});
					this.getDataList();
					this.getDataTree();
					return;
				}

				this.$Notice.success({
					title: "提示",
					desc: "导入" + response.data.count + "条，" +
						'成功' + response.data.successCount +
						'条，失败' + response.data.failureCount +
						'条，忽略' + response.data.skipCount + '条'
				});
				this.getDataList();
				this.getDataTree();
			},
			downTemplate() {
				window.location.href = this.templateUrl + "?" + new Date();
			},
			clickShow(row) {
				this.currentRow = row;
				this.showDetail = true;
			},
			// 修改页面容量
			changePageSize(pageSize) {
				this.pageSize = pageSize;
				this.request();
			},
			changePage(index) {
				this.requestBody = {};
				for (var temp in this.selectedCondition) {
					if (this.selectedCondition[temp] == "meterId") {
						if (this.meterId == "") {
							continue;
						}
						this.requestBody["meterId"] = this.meterId;
					}
				}

				this.loading = true;
				this.currentPage = index;
				this.getDataList();
			},
			searchByCondition() {
				this.requestBody = {};
				for (var temp in this.selectedCondition) {
					if (this.selectedCondition[temp] == "meterId") {
						if (this.meterId == "") {
							continue;
						}
						this.requestBody["meterId"] = this.meterId;
					}
				}

				this.loading = true;
				this.modal8 = false;
				this.currentPage = 1;
				this.getDataList();
			},
			clickBindCustomer(row) {
				this.currentRow = row;
				this.bindCustomerIdCard = '';
				this.showBindCustomer = true;
			},
			submitBindCustomer() {
				let that = this;
				if (that.bindCustomerIdCard == '') {
					that.$Notice.info({
						title: "提示",
						desc: "请输入公司编号"
					});
					return;
				}
				that.submitLoading = true;
				$.ajax({
					url: "/api/meter/admin/address/bindCustomer",
					type: "post",
					data: {
						id: that.currentRow.id,
						customerIdCard: that.bindCustomerIdCard
					},
					success: function(result) {
						if (!result.success) {
							that.$Notice.error({
								title: "异常",
								desc: result.msg
							});
							return;
						}

						that.$Notice.success({
							title: "提示",
							desc: "绑定成功"
						});
						that.showBindCustomer = false;
						that.getDataList();
					},
					error: function(textStatus) {
						that.$Notice.error({
							title: "异常",
							desc: "网络异常"
						});
					},
					complete: function() {
						that.submitLoading = false;
					}
				});
			},
			clickUnbindCustomer(row) {
				let that = this;
				that.$Modal.confirm({
					title: '提示',
					content: '<p>确认解绑？</p>',
					onOk: () => {
						that.loading = true;
						$.ajax({
							url: "/api/meter/admin/address/unbindCustomer",
							type: "post",
							data: {
								id: row.id,
							},
							success: function(result) {
								if (!result.success) {
									that.$Notice.error({
										title: "异常",
										desc: result.msg
									});
									return;
								}

								that.$Notice.success({
									title: "提示",
									desc: "解绑成功"
								});
								that.getDataList();
							},
							error: function(textStatus) {
								that.$Notice.error({
									title: "异常",
									desc: "网络异常"
								});
							},
							complete: function() {
								that.loading = false;
							}
						});
					},
					onCancel: () => {

					}
				});
			},
			renderRootContent(h, {
				root,
				node,
				data
			}) {
				return h("span", {
						style: {
							display: "inline-block",
							width: "100%"
						}
					},
					[
						h("span", [
							h("Icon", {
								props: {
									type: "ios-paper-outline"
								},
								style: {
									marginRight: "8px"
								}
							}),
							h("span", data.name)
						]),
						h("span", {
								style: {
									display: "inline-block",
									marginLeft: "32px",
									marginRight: "32px"
								}
							},
							[
								h("Button", {
									props: Object.assign({}, this.buttonProps, {
										icon: "ios-add",
										type: "primary"
									}),
									on: {
										click: () => {
											this.clickTreeSave(root, node, data);
										}
									}
								})
							]
						)
					]
				);
			},
			renderContent(h, {
				root,
				node,
				data
			}) {
				return h("span", {
						style: {
							display: "inline-block",
							width: "100%"
						}
					},
					[
						h("span", [
							h("Icon", {
								props: {
									type: "ios-paper-outline"
								},
								style: {
									marginRight: "8px"
								}
							}),
							h("span", data.name)
						]),
						h("span", {
								style: {
									display: "inline-block",
									marginLeft: "32px",
									marginRight: "32px"
								}
							},
							[
								h("Button", {
									props: Object.assign({}, this.buttonProps, {
										icon: "ios-add"
									}),
									style: {
										marginRight: "8px"
									},
									on: {
										click: () => {
											this.clickTreeSave(root, node, data);
										}
									}
								}),
								h("Button", {
									props: Object.assign({}, this.buttonProps, {
										icon: "ios-remove"
									}),
									style: {
										marginRight: "8px"
									},
									on: {
										click: () => {
											this.clickTreeDelete(root, node, data);
										}
									}
								}),
								h("Button", {
									props: Object.assign({}, this.buttonProps, {
										icon: "ios-create-outline"
									}),
									style: {
										marginRight: "8px"
									},
									on: {
										click: () => {
											this.clickTreeUpdate(root, node, data);
										}
									}
								}),
							]
						)
					]
				);
			},
			clickTreeSave(root, node, data) {
				this.currentRow = {};
				if (data.id) {
					this.currentRow.parentId = data.id;
				}
				this.showType = 'save';
				this.showTitle = '新增';
				this.showDialog = true;
				if (!data.expand && data.children) {
					this.$set(data, "expand", true);
				}
			},
			clickTreeUpdate(root, node, data) {
				this.currentRow = Object.assign({}, data);
				this.showType = 'update';
				this.showTitle = '编辑';
				this.showDialog = true;
			},
			clickTreeDelete(root, node, data) {
				let that = this;
				if (data.children && data.children.length > 0) {
					that.$Notice.info({
						title: "提示",
						desc: "存在下级，不能删除！"
					});
					this.$set(data, "expand", true);
					return;
				}
				that.$Modal.confirm({
					title: '提示',
					content: '<p>确认删除？</p>',
					onOk: () => {
						that.loading = true;
						$.ajax({
							url: "/api/meter/admin/address/delete",
							type: "post",
							data: {
								id: data.id
							},
							success: function(result) {
								if (!result.success) {
									that.$Notice.error({
										title: "异常",
										desc: result.msg
									});
									return;
								}

								that.getDataTree();
								that.getDataList();
							},
							error: function() {
								that.$Notice.error({
									title: "异常",
									desc: "网络异常"
								});
							},
							complete: function() {
								that.loading = false;
							}
						});
					},
					onCancel: () => {

					}
				});
			},
			submitTreeUpdate() {
				let that = this;
				that.submitLoading = true;
				delete that.currentRow.createTime;
				$.ajax({
					url: "/api/meter/admin/address/" + that.showType,
					type: "post",
					data: that.currentRow,
					success: function(result) {
						if (!result.success) {
							that.$Notice.error({
								title: "异常",
								desc: result.msg
							});
							return;
						}

						that.$Notice.success({
							title: "提示",
							desc: "提交成功"
						});
						that.showDialog = false;
						that.getDataTree();
						that.getDataList();
					},
					error: function(textStatus) {
						that.$Notice.error({
							title: "异常",
							desc: "网络异常"
						});
					},
					complete: function() {
						that.submitLoading = false;
					}
				});
			},
			getDataList() {
				var that = this;
				that.loading = true;
				$.ajax({
					url: "/api/meter/admin/address/getPage?currentPage=" +
						that.currentPage +
						"&pageSize=" +
						that.pageSize +
						"&paging=true",
					type: "post",
					data: that.requestBody,
					success: function(result) {
						if (!result.success) {
							that.$Notice.error({
								title: "异常",
								desc: result.msg
							});
							return;
						}

						that.data1 = result.data.list;
						that.totalRows = result.data.totalRows;
					},
					error: function() {
						that.$Notice.error({
							title: "异常",
							desc: "网络异常"
						});
					},
					complete: function() {
						that.loading = false;
					}
				});
			},
			getDataTree() {
				var that = this;
				that.loading = true;
				$.ajax({
					url: "/api/meter/admin/address/getTree",
					type: "post",
					success: function(result) {
						if (!result.success) {
							that.$Notice.error({
								title: "异常",
								desc: result.msg
							});
							return;
						}

						let arr = [];
						arr.push({
							name: '层级结构',
							expand: true,
							children: result.data,
							render: that.renderRootContent
						});
						that.data2 = arr;
					},
					error: function() {
						that.$Notice.error({
							title: "异常",
							desc: "网络异常"
						});
					},
					complete: function() {
						that.loading = false;
					}
				});
			},
			// 显示条件检索页面
			searchByConditionsView() {
				this.modal8 = true;
			}
		}
	};
</script>

<style>
	.ivu-notice-notice {
		width: 500px;
		right: 160px;
	}

	.query_condition {
		border: 1px solid #c0c0c0;
		padding: 2px;
		margin: 2px;
		border-radius: 5%;
	}

	.check_grop div {
		margin-bottom: 1px;
	}
</style>
